/******************************************************************************
MODULE:  Storage Forms
WHAT IT DOES:  On the quote storage this code is used to control form options
******************************************************************************/
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
      define(['jquery'], factory);
  }
  else if (typeof exports === 'object') {
      module.exports = factory(require('jquery'));
  }
  else {
      root.returnExports = factory(root.jQuery);
  }
}(this, function($) {

  function init() {

    initTelephoneCheckbox();

  }

  function initTelephoneCheckbox() {

    console.log('initTelephoneCheckbox');

    $('body').on('change', '.js-discuss-storage-advisor-checkbox input[type="checkbox"]', function() {
      
      var $this = $(this);
      var $parent = $this.parents('.js-discuss-storage-advisor');
      var $checkbox = $parent.find('.js-discuss-storage-advisor-checkbox');
      var $telephoneContainer = $parent.find('.js-discuss-storage-advisor-telephone');
      var $telephoneInput = $parent.find('.js-discuss-storage-advisor-telephone input[type="tel"]');

      if ($this.is(':checked')) {
        $checkbox.addClass('checked');
        $telephoneContainer.show();
        $telephoneInput.removeAttr('disabled').val('');
      } else {
        $checkbox.removeClass('checked');
        $telephoneContainer.hide();
        $telephoneInput.attr('disabled', 'disabled').val('');
      }

    });    
    
  }

  return {
      init: init
  };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/storage-forms/app.storage-forms.js
 ** module id = 75
 ** module chunks = 24
 **/